import * as React from 'react';
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout';
import DashboardNavbar from 'examples/Navbars/DashboardNavbar';
import CustomTable from '../../components/atoms/Table'
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { Box, Button, IconButton, Paper, Switch, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import ActionMenu from 'admin/components/atoms/ActionButton';
import service from '../../api/services';
import moment from 'moment';
import SoftBox from 'components/SoftBox';
import SoftTypography from 'components/SoftTypography';
import SoftButton from 'components/SoftButton';
import BasicModal from 'components/Modal';
import toast from 'react-hot-toast';
import { useAuth } from 'AuthContext';



const User = () => {
    const navigate = useNavigate()
    const [isApiLoading, setIsApiLoading] = React.useState(true)
    const [data, setData] = React.useState([]);
    const [search, setSearch] = React.useState('');
    const [page, setPage] = React.useState(1);
    const [show, setShow] = React.useState(false);
    const [rowsPerPage, setRowsPerPage] = React.useState(10);
    const [allData, setAllData] = React.useState({})
    const [sortValue, setSortValue] = React.useState({ sortKey: 'name', sortDirection: 'asc' });
    const formatDateWithScheduleFallback = (primaryDate, scheduleType, scheduleTime, createdAt) => {
        if (primaryDate) {
            return moment(primaryDate).format('MM/DD/YYYY');
        }

        if (scheduleType === 'NOW' && createdAt) {
            return moment(createdAt).format('MM/DD/YYYY');
        }

        if (scheduleTime) {
            return moment(scheduleTime).format('MM/DD/YYYY');
        }

        return '-';
    };
    const columns = [
        {
            id: 'title', isSorting: true, sortDirection: 'asc',
            label: 'Campaign',

        },
        {
            id: 'startDate', isSorting: true, sortDirection: 'asc',
            label: 'Start',
            render: (row) => formatDateWithScheduleFallback(row?.startDate, row?.scheduleType, row?.scheduleTime, row?.createdAt),
        },
        {
            id: 'endDate', isSorting: true, sortDirection: 'asc',
            label: 'End',
            render: (row) => formatDateWithScheduleFallback(row?.endDate, row?.scheduleType, row?.scheduleTime, row?.createdAt),
        },
        {
            id: 'targetApp', isSorting: true, sortDirection: 'asc',
            label: 'Target App',
            //   render: (row) => row.targetApp || '-',
        },
        {
            id: 'scheduleType', isSorting: true, sortDirection: 'asc',
            label: 'Schedule Type',
            render: (row) => row?.scheduleType || '-',
        },
        {
            id: 'targetAudience',
            label: 'Target Audience', isSorting: true, sortDirection: 'asc',
            render: (row) => {
                const getNames = (ids, dataList) =>
                    ids.map(id => dataList & dataList?.find(d => d?._id === id)?.name)?.filter(Boolean);

                const countryNames = getNames(row.targetAudience?.country || []);
                const stateNames = getNames(row.targetAudience?.state || []);
                const cityNames = getNames(row.targetAudience?.city || []);
                const subAddLines = row.targetAudience?.subAddLine || [];
                const zipCodes = row.targetAudience?.zipCode || [];

                const allAudience = [
                    ...countryNames,
                    ...stateNames,
                    ...cityNames,
                    ...subAddLines,
                    ...zipCodes
                ].filter(Boolean).join(', ');

                return allAudience || '-';
            }
        },

        {
            id: 'status',
            label: 'Status', isSorting: true, sortDirection: 'asc',
            //   render: (row) => row.status || '-',
        },
        {
            id: 'action',
            label: 'Action',
            render: (row) => (
                <ActionMenu
                    items={[
                        { label: 'Detail', onClick: () => { setAllData(row); setShow(true) } },
                        { label: 'Remove', onClick: () => deleteNotification(row._id) },
                        // add more items as needed
                    ]}
                />
            ),
        },
    ];

    const getUserDetail = async () => {
        setIsApiLoading(true)
        try {
            const response = await service.notification.view({ searchData: search, page, limit: rowsPerPage, sortKey: sortValue.sortKey, sortDirection: sortValue.sortDirection });
            if (response?.data?.data) {
                setData(response.data);
            }
        } catch (error) {
            console.error("Failed to fetch business users", error);
        }
        setIsApiLoading(false)
    };
    const deleteNotification = async (id) => {
        try {
            const response = await service.notification.delete(id);

            if ([200, 201].includes(response.status)) {
                toast.success(response.message || 'deleted successfully.');
                getUserDetail();
            } else {
                toast.error(response.message || 'Failed to delete .');
            }
        } catch (error) {
            const errorMessage = error?.response?.data?.message || 'An error occurred while deleting .';
            toast.error(errorMessage);
            console.error('Deletion error:', error);
        }
    };
    React.useEffect(() => {
        getUserDetail();
    }, [search, page, rowsPerPage, sortValue]);

    function formatTargetAudience(data) {
        return data && Object?.values(data)?.flat()?.map(item => typeof item === 'object' ? item?.name : item)
            .join(', ');
    }
    return (

        <>
            <DashboardLayout>
                <DashboardNavbar />
                <Paper className='glassmorphism-card' sx={{ padding: 2, mt: '15px' }}>
                    <Box display="flex" alignItems="center" justifyContent={'end'}>
                        <SoftButton variant="gradient" color="info" onClick={() => navigate('/admin/add-notification')}>New Campagin</SoftButton>
                    </Box>

                    <CustomTable
                        title="Push Notification" columns={columns}
                        rows={data?.data}
                        search={search}
                        setSearch={setSearch}
                        page={page}
                        setPage={setPage}
                        rowsPerPage={rowsPerPage}
                        isApiLoading={isApiLoading}
                        setRowsPerPage={setRowsPerPage}
                        totalPages={data?.pagination?.totalItems}
                        onRequestSort={(id, direction) => {
                            setSortValue({ sortKey: id, sortDirection: direction })

                        }}
                    />
                </Paper>
            </DashboardLayout>
            <SoftBox>
                <BasicModal
                    show={show}
                    unShow={() => setShow(false)}
                    title="Campaign Details"
                    width={800}
                    height={450}
                >
                    <SoftBox

                    >

                        <hr />
                        <SoftBox mb={1} mt={2} display="flex" gap={2} alignItems="baseline">
                            <SoftTypography variant="caption" fontWeight="bold">Title</SoftTypography>
                            <SoftTypography variant="caption">{allData?.title || "-"}</SoftTypography>
                        </SoftBox>

                        <SoftBox mb={1} display="flex" gap={2} alignItems="baseline">
                            <SoftTypography variant="caption" fontWeight="bold">Message</SoftTypography>
                            <SoftTypography variant="caption">
                                {allData?.message || "-"}
                            </SoftTypography>
                        </SoftBox>

                        <SoftBox mb={1} display="flex" gap={2} alignItems="baseline">
                            <SoftTypography variant="caption" fontWeight="bold">Schedule Type</SoftTypography>
                            <SoftTypography variant="caption">{allData?.scheduleType || "-"}</SoftTypography>
                        </SoftBox>

                        <SoftBox mb={1} display="flex" gap={2} alignItems="baseline">
                            <SoftTypography variant="caption" fontWeight="bold">Start Date</SoftTypography>
                            <SoftTypography variant="caption">
                                {formatDateWithScheduleFallback(allData?.startDate, allData?.scheduleType, allData?.scheduleTime, allData?.createdAt)}
                            </SoftTypography>
                        </SoftBox>

                        <SoftBox mb={1} display="flex" gap={2} alignItems="baseline">
                            <SoftTypography variant="caption" fontWeight="bold">End Date</SoftTypography>
                            <SoftTypography variant="caption">
                                {formatDateWithScheduleFallback(allData?.endDate, allData?.scheduleType, allData?.scheduleTime, allData?.createdAt)}
                            </SoftTypography>
                        </SoftBox>

                        <SoftBox mb={1} display="flex" gap={2} alignItems="baseline">
                            <SoftTypography variant="caption" fontWeight="bold">
                                Schedule Time
                            </SoftTypography>
                            <SoftTypography variant="caption">
                                {allData?.scheduleTime
                                    ? new Date(allData.scheduleTime).toLocaleString("en-US", {
                                        timeZone: "America/New_York",
                                        year: "numeric",
                                        month: "2-digit",
                                        day: "2-digit",
                                        hour: "2-digit",
                                        minute: "2-digit",
                                        hour12: true,
                                    })
                                    : "-"}
                            </SoftTypography>
                        </SoftBox>


                        <SoftBox mb={1} display="flex" gap={2} alignItems="baseline">
                            <SoftTypography variant="caption" fontWeight="bold">Target App</SoftTypography>
                            <SoftTypography variant="caption">{allData?.targetApp || "-"}</SoftTypography>
                        </SoftBox>

                        <SoftBox mb={1} display="flex" gap={2} alignItems="baseline">
                            <SoftTypography variant="caption" fontWeight="bold">User Type</SoftTypography>
                            <SoftTypography variant="caption">{allData?.userType || "-"}</SoftTypography>
                        </SoftBox>

                        <SoftBox mb={1} display="flex" gap={2} alignItems="baseline">
                            <SoftTypography variant="caption" fontWeight="bold">Subscriber Type</SoftTypography>
                            <SoftTypography variant="caption">{allData?.subscriberType || "-"}</SoftTypography>
                        </SoftBox>

                        <SoftBox mb={1} display="flex" gap={2} alignItems="baseline">
                            <SoftTypography variant="caption" fontWeight="bold">Target Audience</SoftTypography>
                            <SoftTypography variant="caption">{allData.targetAudience && formatTargetAudience(allData.targetAudience) || "-"}</SoftTypography>
                        </SoftBox>

                        <SoftBox mb={1} display="flex" gap={2} alignItems="baseline">
                            <SoftTypography variant="caption" fontWeight="bold">Status</SoftTypography>
                            <SoftTypography variant="caption">{allData?.status || "-"}</SoftTypography>
                        </SoftBox>

                        <hr style={{ marginBottom: '20px' }} />
                        <SoftButton
                            variant="outlined"
                            color="error"
                            onClick={() => setShow(false)}
                        >
                            Cancel
                        </SoftButton>

                    </SoftBox>

                </BasicModal>
            </SoftBox>

        </>
    );
}

export default User
